module.exports = __webpack_public_path__ + "static/img/logo_8.d6759cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_8.png
// module id = 9aUd
// module chunks = 1